import React, { useState } from 'react';

import { Button, Flex, Modal, Space, Text } from '@mantine/core';
import { IconWorld } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { LanguageService } from 'services/language-service';

interface LanguageChangeProps {
  menuItem?: boolean;
}

export function LanguageChange({ menuItem = false }: LanguageChangeProps) {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const languages = [
    {
      countryCode: 'US',
      language: 'English',
      locale: 'en'
    },
    {
      countryCode: 'FR',
      language: 'Français',
      locale: 'fr'
    }
  ];

  return (
    <>
      <Modal
        title={
          <Text weight={700} fz={18}>
            {t('APP.CHANGE_LANGUAGE')}
          </Text>
        }
        opened={modalOpen}
        onClose={() => setModalOpen(false)}>
        {languages.map((language, key) => (
          <Flex
            justify="start"
            key={key}
            onMouseDown={() => LanguageService.changeLanguage(language.locale)}
            onTouchStart={() => LanguageService.changeLanguage(language.locale)}
            sx={(theme) => ({
              borderRadius: '15px',
              padding: theme.spacing.lg,
              margin: theme.spacing.xs,
              border: `1px solid ${
                LanguageService.getCurrentLanguage() === language.locale ? theme.colors.dark[9] : theme.colors.gray[3]
              }`,
              ':hover': {
                cursor: 'pointer',
                backgroundColor: theme.colors.gray[0]
              }
            })}>
            {language.language}
          </Flex>
        ))}
      </Modal>
      {menuItem ? (
        <Flex
          direction="row"
          align="center"
          onClick={() => setModalOpen(true)}
          mb={3}
          sx={(theme) => ({
            padding: theme.spacing.xs,
            '&:hover': {
              borderRadius: theme.radius.md,
              backgroundColor: theme.colors.gray[1],
              cursor: 'pointer'
            }
          })}>
          <IconWorld />
          <Space w={10} />
          <Text>{t('APP.LANGUAGE')}</Text>
        </Flex>
      ) : (
        <Button variant="default" leftIcon={<IconWorld />} onClick={() => setModalOpen(true)}>
          {t('APP.LANGUAGE')}
        </Button>
      )}
    </>
  );
}
